import { render } from "./walletMenuLayer2Index.vue?vue&type=template&id=74d9a2fa"
import script from "./walletMenuLayer2Index.vue?vue&type=script&lang=js"
export * from "./walletMenuLayer2Index.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__